import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "big_play_button",
  "use": "big_play_button-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 96 96\" id=\"big_play_button\"><path d=\"M32.111 13.163C26.78 9.969 20 13.81 20 20.026v55.95c0 6.215 6.779 10.056 12.111 6.862l46.7-27.975c5.184-3.106 5.185-10.62 0-13.725l-46.7-27.975Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol